import { render, staticRenderFns } from "./ForceClose.vue?vue&type=template&id=8bd9276a&scoped=true&"
import script from "./ForceClose.vue?vue&type=script&lang=js&"
export * from "./ForceClose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bd9276a",
  null
  
)

export default component.exports